// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2g7xM","buttons":"styles_buttons__3cSph"};